// SettingsMenuDefaultOsmStyle.js
import React, { useEffect, useState } from "react";
import { Box, Button, Collapsible, ColorPicker, Field, For, HStack, Input, parseColor, SimpleGrid, Text } from "@chakra-ui/react";
import { rgbaToHex, saveToCache } from "../../../utilies/Utility";
import { applyOSMStyleToEntitiesByType } from "../../../utilies/OsmUtility";
import Type from "../../../utilies/Types";
import { useAppStore } from "../../../context/store";

const BasicOSMStyle = ({ data, title, keyG }) => {
  // state
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setter
  const setDefaultOsmStyle = useAppStore.getState().setDefaultOsmStyle;

  const [width, setWidth] = useState(data?.defaultLineWidth);
  const [outlineColor, setOutlineColor] = useState(data?.defaultOutlineColor);
  const [insideColor, setInsideColor] = useState(data?.defaultFillColor);

  useEffect(() => {
    setWidth(data?.defaultLineWidth);
    setOutlineColor(data?.defaultOutlineColor);
    setInsideColor(data?.defaultFillColor);
  }, [data]);

  return (
    <Collapsible.Root mb={1}>
      <Collapsible.Trigger paddingY="3" bg={"blackAlpha.100"} px={3} width={"full"} textAlign={"left"} cursor={"pointer"} borderRadius={"lg"} fontWeight={"medium"}>
        {title}
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Box padding="4" borderWidth="1px" mt={1}>
          <SimpleGrid columns={2} gap={2} pb={2} px={3}>
            {data?.defaultLineWidth != null && data?.defaultLineWidth != undefined && (
              <Field.Root mb={2}>
                <Field.Label>Width</Field.Label>
                <Input
                  placeholder="Enter Line Width"
                  type="number"
                  value={width}
                  onChange={(v) => {
                    let w = "0";
                    if (v.target.value) {
                      w = v.target.value;
                    }

                    setWidth(w);

                    setDefaultOsmStyle((prev) => {
                      const updated = {
                        ...prev,
                        [keyG]: {
                          ...prev[keyG],
                          defaultLineWidth: parseInt(w),
                        },
                      };

                      saveToCache(Type.STORAGE.DEFAULT_OSM_STYLE, updated);

                      return updated;
                    });
                  }}
                />
              </Field.Root>
            )}
            {data?.defaultOutlineColor && (
              <ColorPicker.Root
                value={parseColor(outlineColor)}
                onValueChange={(v) => {
                  setOutlineColor(rgbaToHex(v.valueAsString));

                  setDefaultOsmStyle((prev) => {
                    const updated = {
                      ...prev,
                      [keyG]: {
                        ...prev[keyG],
                        defaultOutlineColor: rgbaToHex(v.valueAsString),
                      },
                    };

                    saveToCache(Type.STORAGE.DEFAULT_OSM_STYLE, updated);

                    return updated;
                  });
                }}
              >
                <ColorPicker.HiddenInput />
                <ColorPicker.Label>Outline Color</ColorPicker.Label>
                <ColorPicker.Control>
                  <ColorPicker.Input />
                  <ColorPicker.Trigger />
                </ColorPicker.Control>
                <ColorPicker.Positioner>
                  <ColorPicker.Content>
                    <ColorPicker.Area />
                    <HStack>
                      <ColorPicker.EyeDropper size="xs" variant="outline" />
                      <ColorPicker.Sliders />
                    </HStack>
                  </ColorPicker.Content>
                </ColorPicker.Positioner>
              </ColorPicker.Root>
            )}
            {data?.defaultFillColor && (
              <ColorPicker.Root
                value={parseColor(insideColor)}
                onValueChange={(v) => {
                  setInsideColor(rgbaToHex(v.valueAsString));

                  setDefaultOsmStyle((prev) => {
                    const updated = {
                      ...prev,
                      [keyG]: {
                        ...prev[keyG],
                        defaultFillColor: rgbaToHex(v.valueAsString),
                      },
                    };

                    saveToCache(Type.STORAGE.DEFAULT_OSM_STYLE, updated);

                    return updated;
                  });
                }}
              >
                <ColorPicker.HiddenInput />
                <ColorPicker.Label>Inside Color</ColorPicker.Label>
                <ColorPicker.Control>
                  <ColorPicker.Input />
                  <ColorPicker.Trigger />
                </ColorPicker.Control>
                <ColorPicker.Positioner>
                  <ColorPicker.Content>
                    <ColorPicker.Area />
                    <HStack>
                      <ColorPicker.EyeDropper size="xs" variant="outline" />
                      <ColorPicker.Sliders />
                    </HStack>
                  </ColorPicker.Content>
                </ColorPicker.Positioner>
              </ColorPicker.Root>
            )}
          </SimpleGrid>
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

function SettingsMenuDefaultOsmStyle() {
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);
  const viewerRef = useAppStore.getState().viewerRef;

  const applyChangesForOsm = () => {
    applyOSMStyleToEntitiesByType(viewerRef.current, defaultOsmStyle);
  };

  return (
    <>
      <For each={Object.entries(defaultOsmStyle)}>{([key, item]) => <BasicOSMStyle key={key} data={item} title={item.title} keyG={key} />}</For>

      <HStack justify={"space-between"} width={"full"}>
        <Text>These settings are saved automatically</Text>
        <Button colorPalette={"black"} onClick={applyChangesForOsm}>
          Apply
        </Button>
      </HStack>
    </>
  );
}

export default SettingsMenuDefaultOsmStyle;
